<template>
    <div class="form-container">
        <el-form v-loading="loading" ref="postForm" :validate-on-rule-change="false" v-if="postForm" :model="postForm" :rules="rules" class="form-container" :label-position="labelPosition" label-width="505px">
            <sticky :class-name="'sub-navbar draft'">
                <el-button v-loading="loading" size="small" @click="save()" type="success">Enviar</el-button>
            </sticky>

            <h2>Termos e Contratos</h2>
            <p>Faça o download do formulário de EPI abaixo, preencha e em seguida anexe no campo respectivo:</p>

            <el-button-group>
                <a class="el-button el-button--default" target="_blank" href="/modelos/Ficha de EPI ATUAL.pdf">Formulário de EPI</a>
            </el-button-group>

            <br>
            <br>

            <el-form-item label="Anexe aqui seu formulário de EPI preenchido" prop="anexo_formulario_epi" class="postInfo-container-item is-required">
                <el-upload-x action="" accept="application/pdf" :auto-upload="false" class="flex" :multiple="false" :limit="1" ref="anexo_formulario_epi" prop="anexo_formulario_epi">
                    <el-tooltip class="item" effect="dark" content="Anexar Documento" placement="top-start">
                        <el-button type="primary">Importar</el-button>
                    </el-tooltip>
                </el-upload-x>
                <upload-error prop="anexo_formulario_epi" :errors="invalidUploads"/>
            </el-form-item>

        </el-form>
    </div>
</template>


<script>
import request from '@/request'
import Sticky from '@/components/Sticky'
import ElUploadX from '@/components/Upload/src'
import UploadError from '@/components/UploadError'

export default {
    name: 'ContratoEPIForm',
    components: { Sticky, UploadError, ElUploadX },
    data() {
        return {
            loading: false,
            labelPosition: 'left',
            postForm: {},
            admissao: null,
            invalidUploads: [],
            rules: {}
        }
    },
    created() {
        this.fetchData();
    },
    computed: {
        displayNoShow() {
            return this.admissao && this.admissao.empresa.nome.startsWith('HRT') && this.admissao.contrato.tipo.endsWith('Offshore')
        }
    },
    methods: {
        fetchData() {
            request({
                url: `funcionario/${this.$route.params.uid}/formulario-epi`,
                method: 'get',
            }).then(response => {
                this.loading = false
                this.admissao = response.data
            }, error => {
                this.loading = false
                if ( error.response.status === 404) {
                    this.$router.push('/contrato/invalido')
                } else {
                    this.$message({
                        showClose: true,
                        message: `Falha ao recuperar dados do formulário ${error.bodyText}`,
                        type: 'error'
                    })
                }
            })
        },
        save() {
            const data = this.prepareData()
            this.$refs['postForm'].validate(valid => {
                if (valid && this.invalidUploads.length == 0) {
                    this.loading = true
                    request({
                        url: `funcionario/${this.$route.params.uid}/contrato`,
                        method: 'POST',
                        data: data,
                        headers: {
                        'Content-Type': 'multipart/form-data'
                        }
                    }).then(() => {
                        this.loading = false
                        this.$router.push('/contrato/finalizado')
                    }, error => {
                        this.loading = false
                        this.$message({
                            showClose: true,
                            message: `Falha ao salvar formulário: ${error.response.data.description}`,
                            type: 'error'
                        })

                        if (error.response.data.fields) {
                            error.response.data.fields.forEach(postFile => {
                                this.invalidUploads.push({key: postFile.key, message: 'Formato ' + postFile.mimetype + ' inválido'})
                            })
                        }
                    })
                } else {
                    this.loading = false
                }
            })
        },
        prepareData() {

            this.invalidUploads = []
            const formData = new FormData()
            const anexos = Object.keys(this.$refs).filter(item => {
                return item.startsWith('anexo')
            })

            anexos.forEach(postFile => {
                let upload = this.$refs[postFile];
                if (Array.isArray(this.$refs[postFile])) {
                    upload = this.$refs[postFile][0]
                }
                //upload.disabled
                if (upload.uploadFiles[0]) {
                    if (upload.uploadFiles[0].raw) {
                        formData.append(postFile, upload.uploadFiles[0].raw)
                    }
                } else {
                    if (!upload.disabled) {
                        this.invalidUploads.push({key: postFile, message: 'Upload obrigatório'})
                    }
                }
            }, this)
            return formData
        }
    }
}
</script>

<style>
.sub-navbar {
  height: 50px;
  line-height: 50px;
  position: relative;
  width: 100%;
  text-align: right;
  padding-right: 20px;
  transition: 600ms ease position;
  background: #F2F6FC;
}
</style>
